/* eslint-disable unicorn/filename-case */
import { Routes } from 'app/routes/route'

const App = () => {
  return <Routes />
}
export default App
